module.exports = __webpack_public_path__ + "ir.7c8e6cb3.svg";